export const getMaxCancellationMinutesThreshold = (events) => {
    if (!events || events.length === 0) {
        return 0;
    }
    return events.reduce((maxThreshold, event) => {
        const threshold = event?.cancellationMinutesThreshold || 0;
        return Math.max(maxThreshold, threshold);
    }, 0);
};
